import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { stashPartnerSlug, flushPartnerAttribution } from "../lib/api";

/**
 * PartnerLandingRoute — the public, slug-driven partner entry point.
 *
 * Behaviour:
 *   1. Resolves the slug from the URL param (`/r/:slug`) or a hard-coded
 *      prop (`/topedu` alias).
 *   2. Stashes the slug in localStorage so attribution survives
 *      registration and checkout (first-touch within 30 days; direct
 *      partner URL overrides earlier touches — enforced server-side).
 *   3. If the user is already authenticated, posts to
 *      `/api/partners/attribute` immediately so the attribution lands in
 *      the DB on this visit (idempotent on the server).
 *   4. Redirects to the Landing page. The brand remains MyAE at all times.
 *
 * No UI is rendered — this is a pass-through. If the slug is invalid or
 * the partner is suspended, the server silently drops the write; the user
 * still lands on `/` and no partner is revealed.
 */
export default function PartnerLandingRoute({ slug: fixedSlug }) {
  const params = useParams();
  const slug = (fixedSlug || params?.slug || "").trim().toLowerCase();

  useEffect(() => {
    if (!slug) return;
    stashPartnerSlug(slug, "direct_link");
    // Fire-and-forget — unauthenticated POSTs return 401 and that's fine;
    // the AuthContext will replay from localStorage on next login.
    flushPartnerAttribution().catch(() => {});
  }, [slug]);

  return <Navigate to="/" replace />;
}
